import "./Header.css";

import TopBar from "./TopBar";
import MainHeader from "./MainHeader";
import CategoryBar from "./CategoryBar";
import { useEffect, useState } from "react";

function Header(props) {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {

    const handleScroll = () => {

        const y = window.scrollY;

        setScrolled(prev => {

            if (!prev && y > 80) {
                return true;      // Hide
            }

            if (prev && y < 40) {
                return false;     // Show
            }

            return prev;          // Keep current state
        });
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

}, []);
    return (
        <header className={`header-wrapper ${scrolled ? "header-scrolled" : ""}`}>

            <TopBar {...props} />

            <MainHeader {...props} />

            <CategoryBar />

        </header>
    );
}

export default Header;